import esContent from './useDnsModal.es';

export default {
  ...esContent,
};
